<script setup lang="ts">
import { Motion } from "motion-v";
</script>

<template>
  <!-- Background Elements -->
  <div class="absolute inset-0 -z-10">
    <Motion
      :initial="{ opacity: 0, scale: 0.8 }"
      :animate="{ opacity: 1, scale: 1 }"
      :transition="{ duration: 1.2, ease: 'easeInOut' }"
    >
      <div
        class="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
        aria-hidden="true"
      >
        <div
          class="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#8099ff] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
          :style="{
            clipPath:
              'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
          }"
        />
      </div>
    </Motion>
  </div>

  <main
    class="overflow-hidden [--color-primary-foreground:var(--color-white)] [--color-primary:var(--color-green-600)]"
  >
    <section>
      <div class="relative mx-auto max-w-6xl px-6 pb-20 pt-32 lg:pt-48">
        <div class="relative z-10 mx-auto max-w-4xl text-center">
          <!-- Hero Headline -->
          <div class="space-y-4 mb-8">
            <Motion
              :initial="{ opacity: 0, y: 30 }"
              :animate="{ opacity: 1, y: 0 }"
              :transition="{ duration: 0.8, delay: 0.2, ease: 'easeOut' }"
            >
              <h1
                class="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight"
              >
                Affordable eSIM data<br class="hidden sm:block" />
                for international travel
              </h1>
            </Motion>
            <Motion
              :initial="{ opacity: 0, y: 20 }"
              :animate="{ opacity: 1, y: 0 }"
              :transition="{ duration: 0.6, delay: 0.6, ease: 'easeOut' }"
            >
              <p class="text-xl md:text-2xl text-blue-400 font-semibold mt-6">
                Data that travels as fast as you do.
              </p>
            </Motion>
          </div>

          <div class="mt-12">
            <div
              aria-hidden
              class="bg-radial from-primary/50 dark:from-primary/25 relative mx-auto mt-32 max-w-2xl to-transparent to-55% text-left"
            >
              <div
                class="bg-background border-border/50 absolute inset-0 mx-auto w-80 -translate-x-3 -translate-y-12 rounded-[2rem] border p-2 [mask-image:linear-gradient(to_bottom,#000_50%,transparent_90%)] sm:-translate-x-6"
              >
                <div
                  class="relative h-96 overflow-hidden rounded-[1.5rem] border p-2 pb-12 before:absolute before:inset-0 before:bg-[repeating-linear-gradient(-45deg,var(--color-border),var(--color-border)_1px,transparent_1px,transparent_6px)] before:opacity-50"
                />
              </div>
              <div
                class="bg-transparent border-0 mx-auto w-80 translate-x-4 rounded-[2rem] p-2 [mask-image:linear-gradient(to_bottom,#000_50%,transparent_90%)] sm:translate-x-8"
              >
                <Motion
                  :initial="{ opacity: 0, y: 50 }"
                  :animate="{ opacity: 1, y: 0 }"
                  :transition="{ duration: 0.8, delay: 0.2, ease: 'easeOut' }"
                >
                  <img
                    src="/product/hero.webp"
                    alt="App"
                    class="w-full h-96 object-cover object-top rounded-lg"
                  />
                </Motion>
              </div>
              <div
                class="absolute inset-0 bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] mix-blend-overlay [background-size:16px_16px] [mask-image:radial-gradient(ellipse_50%_50%_at_50%_50%,#000_70%,transparent_100%)] dark:opacity-5"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
